export default "__VITE_ASSET__B8HZVG6k__"